import { getCrossPlatformAccountId } from "../../helpers/bearerToken";
import { getPacvueAuthorizationHeader } from "../../helpers/pacvueToken";
import { baseFetchSimple, PacvueUnauthorizedError } from "./baseFetchSimple";
import { refreshPacvueTokenDebounced } from "./refreshPacvueToken";
/**
 * this function make 'fetches' while taking care of refreshing Pacvue tokens.
 *
 * Steps(pseudo code not line-by-line match source code):
 *
 * 1. make the request
 * 2. IF success
 *    2.1. return response
 *    2.2. end procedure
 * 3. IF Pacvue token expires (only happens when requesting Pacvue APIs for now)
 *    3.1. save the error as 'E'
 *    3.2. IF refresh token success
 *         3.2.1. update token in request
 *         3.2.2. make the request again
 *    3.3. ELSE refresh token (fail)
 *         3.3.1. throw the error 'E'
 * 4. ELSE other error
 *    3.1. throw the error
 */
export async function pacvueTokenAwareFetch(request) {
    try {
        return await baseFetchSimple(request);
    }
    catch (e) {
        // pacvue token expired, let's get a new one with current refresh-token
        if (e instanceof PacvueUnauthorizedError) {
            if (await refreshPacvueTokenDebounced()) {
                updatePacvueAuthHeader(request);
                return await baseFetchSimple(request);
            }
            else {
                throw e.response;
            }
        }
        else {
            throw e;
        }
    }
}
async function updatePacvueAuthHeader(request) {
    const accountId = await getCrossPlatformAccountId();
    if (accountId) {
        const newAuthHeader = await getPacvueAuthorizationHeader(String(accountId));
        request.headers = {
            ...request.headers,
            ...newAuthHeader,
        };
    }
}
